import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthToken } from "jwt-storage-lib";
import { User } from "@builder/types/Users.type";
import { buildUrlQuery } from "@builder/utils/buildUrlQuery";

export const usersApi = createApi({
    reducerPath: "usersApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${import.meta.env.VITE_URL_HUB_API}user`,
        prepareHeaders: async headers => {
            const token = await getAuthToken();

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;
        }
    }),
    tagTypes: ["users"],
    endpoints: builder => ({
        getUsers: builder.query<User[], { companyId: string; search?: string; skip?: number; limit?: number; organizationId?: string }>({
            query: ({ companyId, ...query }) => `/builder/query/${companyId}?${buildUrlQuery(query)}`,
            providesTags: ["users"]
        }),
        getUsersByIds: builder.query<User[], { companyId: string; ids: string[]; organizationId?: string }>({
            query: ({ companyId, ids, organizationId }) => {
                const params = new URLSearchParams({ ids: ids.join(",") });
                if (organizationId) {
                    params.append("organizationId", organizationId);
                }
                return `/builder/by-ids/${companyId}?${params.toString()}`;
            },
            providesTags: ["users"]
        }),
        updateUser: builder.mutation<User, { companyId: string; userId: string; firstName?: string; lastName?: string }>({
            query: ({ companyId, userId, ...body }) => ({
                url: `/update-user/${companyId}/${userId}`,
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body
            }),
            invalidatesTags: ["users"]
        })
    })
});

export const { useGetUsersQuery, useGetUsersByIdsQuery, useUpdateUserMutation } = usersApi;
